export const TIMEZONES = {
  'Africa/Nairobi': 'UTC+3: Africa - Nairobi',
  'America/Los_Angeles': 'UTC-8 / UTC-7: America - Los Angeles',
  'America/Puerto_Rico': 'UTC-4: America - Puerto Rico',
  'America/Toronto': 'UTC-5 / UTC-4: America - Toronto',
  'Asia/Bangkok': 'UTC+7: Asia - Bangkok',
  'Asia/Dubai': 'UTC+4: Asia - Dubai',
  'Europe/London': 'UTC+0 / UTC+1: Europe - London, Dublin, Lisbon',
  'Europe/Malta': 'UTC+1 / UTC+2: Europe - Valletta, Zurich, Budapest',
}
